"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SalesDashboardExcelFile_1 = require("../model/SalesDashboardExcelFile");

var SalesDashboardExcelFileConverter_1 = require("./SalesDashboardExcelFileConverter");

var SalesDashboardExcelFileConverterImpl =
/*#__PURE__*/
function (_SalesDashboardExcelF) {
  _inherits(SalesDashboardExcelFileConverterImpl, _SalesDashboardExcelF);

  function SalesDashboardExcelFileConverterImpl() {
    _classCallCheck(this, SalesDashboardExcelFileConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SalesDashboardExcelFileConverterImpl).apply(this, arguments));
  }

  _createClass(SalesDashboardExcelFileConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new SalesDashboardExcelFile_1.SalesDashboardExcelFile(SalesDashboardExcelFile_1.SalesDashboardExcelFile.schema.id.valueOf(conversions.documentToClassId(source)), SalesDashboardExcelFile_1.SalesDashboardExcelFile.schema.fileId.valueOf(conversions.toClassReferenceId(source.fileId)), SalesDashboardExcelFile_1.SalesDashboardExcelFile.schema.note.valueOfField(source));
    }
  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        fileId: conversions.toDocumentReferenceId(source.fileId)
      });
      Object.assign(result, {
        note: source.note
      });
      return result;
    }
  }]);

  return SalesDashboardExcelFileConverterImpl;
}(SalesDashboardExcelFileConverter_1.SalesDashboardExcelFileConverter);

exports.SalesDashboardExcelFileConverterImpl = SalesDashboardExcelFileConverterImpl;